var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGlobe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#globe_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.734 9h2.988a13.75 13.75 0 0 1 2.001-5.973A7.34 7.34 0 0 0 2.734 9M10 3.234A11.75 11.75 0 0 0 7.732 9h4.536A11.75 11.75 0 0 0 10 3.234M12.268 11A11.75 11.75 0 0 1 10 16.766 11.75 11.75 0 0 1 7.732 11zm-6.546 0H2.734a7.34 7.34 0 0 0 4.99 5.973A13.75 13.75 0 0 1 5.721 11m6.554 5.973A13.75 13.75 0 0 0 14.278 11h2.988a7.34 7.34 0 0 1-4.99 5.973M17.266 9h-2.988a13.75 13.75 0 0 0-2.002-5.973A7.34 7.34 0 0 1 17.266 9m-16.6 1a9.333 9.333 0 1 1 18.667 0A9.333 9.333 0 0 1 .667 10",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "globe_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
SvgGlobe.displayName = "SvgGlobe";
export { SvgGlobe as ReactComponent };
export default SvgGlobe;